import React, { FC } from "react"
import { NavLink, withRouter, match } from "react-router-dom"

interface Props<Params extends { [K in keyof Params]?: string } = {}> {
  history: any
  location: any
  match: match<Params>
  staticContext?: any
}

const Sidenav: FC<Props> = ({ match: { path } }) => {
  const links = [
    { name: "feed", to: "feed", icon: "home" },
    { name: "charts", to: "charts", icon: "trending_up" },
    { name: "featured", to: "featured", icon: "star_outline" },
    { name: "explore", to: "discover", icon: "explore" },
    { name: "playlist", to: "playlist", icon: "subject" },
  ]

  return (
    <div className="sidenav">
      <div className="sidenav-body">
        <div className="sidenav-items">
          <div className="logo thmcl">
            <a className="ls" href="#!">
              <span className="lg">
                <i className="material-icons">album</i>
                <span className="ls">Lodies</span>
              </span>
            </a>
            <a className="ss" uk-toggle="target: #drawer" href="#!">
              <i className="material-icons">album</i>
            </a>
          </div>
          <div className="sidenav-links">
            <ul className="links ls">
              {links &&
                links.map(({ name, to, icon }) => {
                  return (
                    <NavLink key={name} to={`/${to}`}>
                      <li
                        className={`link ${path === "/" + to ? `active` : ``}`}
                      >
                        <i className="material-icons-outlined md-24">{icon}</i>
                        <span>{name}</span>
                      </li>
                    </NavLink>
                  )
                })}
            </ul>
            <ul className="links ss">
              {links &&
                links.map(({ name, to, icon }) => {
                  return (
                    <NavLink key={name} to={`/${to}`}>
                      <li
                        className={`link ${path === "/" + to ? `active` : ``}`}
                      >
                        <i className="material-icons-outlined md-24">{icon}</i>
                      </li>
                    </NavLink>
                  )
                })}
            </ul>
            <div className="ls settings">
              <div>
                <i className="material-icons-outlined md-24">settings</i>
                <span>Settings</span>
              </div>
            </div>
            <div className="ss">
              <i className="material-icons-outlined md-24">settings</i>
            </div>
          </div>
        </div>
      </div>
    </div>
    // <div className="link-container">
    //   <div>
    //     <div className="logo link">
    //       <Target />
    //       <span className="med-and-large logo-text">Lodies</span>
    //     </div>
    //     <div className="links">
    //       {links &&
    //         links.map(({ name, to, icon }, i) => {
    //           return (
    //             <NavLink
    //               className={`link ${path === "/" + to ? `active` : ``}`}
    //               exact
    //               to={`/${to}`}
    //               key={i}
    //             >
    //               {icon}
    //               <span className="links-up">{name}</span>
    //             </NavLink>
    //           )
    //         })}
    //     </div>
    //   </div>
    //   <div className="links-dn show-expanded">
    //     <span uk-toggle="target: #drawer">
    //       <ChevronRight />
    //     </span>
    //   </div>
    // </div>
  )
}

export default withRouter(Sidenav)
